import {RestService} from "@/services/rest/RestService";
import {ImportAPIApi} from "@/api/pharma-cpc-import";
import {
    AsyncHandlingResponseRestDto,
    HandleCsvRequestRestDto,
    HandleXlsxRequestRestDto,
    PrepareCsvHandlingRequestRestDto, PrepareImportHandlingResponseRestDto,
    PrepareXlsxHandlingRequestRestDto
} from "@/api/pharma-cpc-import/models";

export class ImportRestService extends RestService {

    private apiService: ImportAPIApi;


    protected constructor() {
        super();
        this.apiService = new ImportAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cpcUrl);
    }

    public async handleCsv(
        handleCsvRequest: HandleCsvRequestRestDto,
        importTypeCode: string
    ): Promise<AsyncHandlingResponseRestDto> {
        const response =
            await this.apiService.handleCsv(handleCsvRequest, importTypeCode);
        return response.data;
    }

    public async handleXlsx(
        handleXlsxRequest: HandleXlsxRequestRestDto,
        importTypeCode: string
    ): Promise<AsyncHandlingResponseRestDto> {
        const response =
            await this.apiService.handleXlsx(handleXlsxRequest, importTypeCode);
        return response.data;
    }

    public async prepareCsvHandling(
        prepareCsvHandlingRequest: PrepareCsvHandlingRequestRestDto,
        importTypeCode: string
    ): Promise<PrepareImportHandlingResponseRestDto> {
        const response =
            await this.apiService.prepareCsvHandling(prepareCsvHandlingRequest, importTypeCode);
        return response.data;
    }

    public async prepareXlsxHandling(
        prepareXlsxHandlingRequest: PrepareXlsxHandlingRequestRestDto,
        importTypeCode: string
    ): Promise<PrepareImportHandlingResponseRestDto> {
        const response =
            await this.apiService.prepareXlsxHandling(prepareXlsxHandlingRequest, importTypeCode);
        return response.data;
    }
}
